import { AxiosResponse } from 'axios'
import { http } from '../../../utils/http'
import { ItemEntry, Response } from '../../../services'

export interface FetchEntryByIdResponse extends Response {
  data: ItemEntry
}

export const fetchEntryById = async (
  entryId: number
): Promise<FetchEntryByIdResponse> => {
  try {
    const response = await http.get(`/entry/pvt?entry_id=${entryId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching entry by id:', error)
    throw error
  }
}
